import styled from 'styled-components';

export const Container = styled.div`
    position: relative;

    border-radius: ${({ theme }) => theme.borderRadius.default};

    height: 100%;
    width: 100%;
`;

export const TopActionsContainer = styled.div`
    position: absolute;
    top: ${({ theme }) => theme.spacing[4]};
    right: ${({ theme }) => theme.spacing[4]};
    z-index: 1000;
    display: flex;
    gap: ${({ theme }) => theme.spacing[2]};
`;

export const ZoomButtonsContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${({ theme }) => theme.spacing[2]};
    
    position: absolute;
    top: ${({ theme }) => theme.spacing[4]};
    left: ${({ theme }) => theme.spacing[4]};
    
    z-index: 1000;
`;

export const ActionButtons = styled.button`
    width: 2.5rem;
    height: 2.5rem;

    background-color: ${({ theme }) => theme.colors.gray000};
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 0.625rem ${({ theme }) => theme.colors.shadow.small};
    border: none;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.gray800};
    transition: all 0.2s ease;

    &:hover {
        background-color: ${({ theme }) => theme.colors.gray200};
    }
`;